/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-confusing-void-expression */

import { type ChangeEvent, useState } from 'react';
import { Typography, Grid, TextField } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { strings } from 'i18n/Strings';
import { useDispatch } from 'react-redux';
import { exportOrdersReport } from 'service/OrderService';
import { transactionTypes } from 'constants/constantText';
import { setSnackBarFailed, setSnackBarSuccess } from 'store/snackBar';

const SellOrders = (): JSX.Element => {
  const [date, setDate] = useState('');
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const handleSetDate = (e: ChangeEvent<HTMLInputElement>): void => {
    setDate(e.target.value);
  };

  const handleExportSellReport = async (): Promise<void> => {
    setLoading(true);
    if (!date) {
      setLoading(false);
      dispatch(
        setSnackBarFailed({
          snackBarMessage: strings.displayText.noReportDateError,
        }),
      );
      return;
    }
    try {
      const url = await exportOrdersReport(transactionTypes.sell, date);
      const link = document.createElement('a');
      link.href = url as string;
      link.download = `Orders_Report_SELL_${date}`;
      link.click();
      dispatch(
        setSnackBarSuccess({
          snackBarMessage: strings.displayText.sellOrderReportExportSuccess,
        }),
      );
    } catch (error) {
      console.log('Error in exporting sell order');
      dispatch(
        setSnackBarFailed({
          snackBarMessage: strings.displayText.sellOrderReportExportFailed,
        }),
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={12}>
        <Typography variant="h4" component="h2" sx={{ marginBottom: 2 }}>
          {strings.displayText.dailyReportSellLabel}
        </Typography>
      </Grid>
      <Grid item sx={{ minWidth: 250 }}>
        <TextField
          type="date"
          value={date}
          onChange={handleSetDate}
          InputLabelProps={{
            shrink: true,
          }}
          fullWidth
        />
      </Grid>
      <Grid item>
        <LoadingButton
          loading={loading}
          variant="contained"
          onClick={handleExportSellReport}
        >
          {strings.displayText.export}
        </LoadingButton>
      </Grid>
    </Grid>
  );
};

export default SellOrders;
